module.exports = __webpack_public_path__ + "static/img/xajyzx.8787756.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/tabs/xajyzx.png
// module id = 6Fdi
// module chunks = 1